import React from 'react';
import { AdminSidebarComponentProps } from '../JsonComponent.types';
import { LayoutAddComponentListItem } from '@website-editor/features/custom-page/components/LeftPanelLayouts/LayoutAddComponentListItem';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useGoToCreateView } from '../hooks/useJsonComponentNavigation';
import { ComponentType } from '@graphql/generated';
import { useEventInfo } from '@shared/utils/eventInfo';
import { SimpleGrabHandle } from '@website-editor/components/SimpleGrabHandle';
import { WeatherReportConfig } from './WeatherReport.config';
import { TextV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core/i18n';
import { Experiences } from '@withjoy/joykit/icons';
import { createWeatherReportTemplate, deriveLegTitle } from './WeatherReport.helpers';
import type { WeatherReportContentV103 } from './WeatherReport.types';
import { WEATHER_REPORT_SCHEMA_URL } from './WeatherReport.constants';

export const WeatherReportGrabber: React.FC<AdminSidebarComponentProps> = props => {
  const { t } = useTranslation('websiteEditor');
  const customPageTrans = t('customPage');
  const content = props.componentData.containerContent.content as WeatherReportContentV103 | null | undefined;
  const firstLeg = content?.itinerary?.[0];
  const title = firstLeg ? deriveLegTitle(firstLeg, customPageTrans.weatherReport.title()) : customPageTrans.weatherReport.title();
  return (
    <SimpleGrabHandle
      title={title}
      icon={<Experiences size={32} />}
      {...props}
    ></SimpleGrabHandle>
  );
};

export const WeatherReportAdd: React.FC<AdminSidebarComponentProps> = props => {
  const { t } = useTranslation('websiteEditor');
  const customPageTrans = t('customPage');
  const { goToCreateView } = useGoToCreateView();
  const eventInfo = useEventInfo();
  const eventLocation = eventInfo?.eventInfo?.locationInfo?.city;
  const country = eventInfo?.eventInfo?.locationInfo?.country;
  const eventId = eventInfo?.eventInfo?.eventId;

  const handleClick = useEventCallback(() => {
    const initial = createWeatherReportTemplate();
    const [firstItineraryLeg] = initial.itinerary;
    if (firstItineraryLeg) {
      firstItineraryLeg.label = eventLocation || firstItineraryLeg.label;
      firstItineraryLeg.location = {
        ...(firstItineraryLeg.location || {}),
        city: eventLocation || firstItineraryLeg.location?.city,
        country: country || firstItineraryLeg.location?.country,
      };
    }

    goToCreateView({
      id: props.containerId,
      containerContent: {
        id: props.containerId,
        type: WeatherReportConfig.componentType,
        content: initial,
        eventId: eventId || '',
        schemaUrl: WEATHER_REPORT_SCHEMA_URL,
      },
      type: ComponentType.jsonDataBlob,
      sortOrder: 0,
      jsonDataContainerId: props.containerId,
      __typename: 'JsonDataBlobComponent',
    });
  });

  return (
    <LayoutAddComponentListItem onClick={handleClick}>
      <Experiences size={48} />
      <TextV2
        typographyVariant="hed2"
        textAlign="left"
      >
        {customPageTrans.weatherReport.title()}
      </TextV2>
    </LayoutAddComponentListItem>
  );
};
